import React, { useState, useEffect } from 'react';
import './Skill.css';
import Progress from '../Progress/Progress';
// import ProgressCard from '../Progress/ProgressCard';
import cssImage from '../../images/skill-image/css3-logo-png-transparent.png'
import firebase from '../../images/skill-image/firebase.png'
import netlify from '../../images/skill-image/netlify.png'
import vscode from '../../images/skill-image/vscode.png'
import devTool from '../../images/skill-image/devTool.png'
import expressJs from '../../images/skill-image/express.png'
import nextJs from '../../images/skill-image/nextjs.png';
import tailwindCSS from '../../images/skill-image/taliwind.png';
import laravelIcon from '../../images/skill-image/laravel.png';

const Skill = () => {

    const allSkill = [
        { id: "01", skillType: 'web', skill: "Laravel", expertLevel: 75, logoUrl: laravelIcon },
        { id: "02", skillType: 'web', skill: "React", expertLevel: 90, logoUrl: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K' },
        { id: "022", skillType: 'web', skill: "Next.JS", expertLevel: 90, logoUrl: nextJs },
        { id: "03", skillType: 'web', skill: "Redux", expertLevel: 90, logoUrl: 'https://redux.js.org/img/redux.svg' },
        { id: "04", skillType: 'web', skill: "Node.JS", expertLevel: 80, logoUrl: 'https://nodejs.org/static/images/logo.svg' },
        { id: "05", skillType: 'web', skill: "Express.JS", expertLevel: 75, logoUrl: expressJs },
        { id: "06", skillType: 'web', skill: "MongoDB", expertLevel: 90, logoUrl: 'https://webimages.mongodb.com/_com_assets/cms/kuyj3d95v5vbmm2f4-horizontal_white.svg?auto=format%252Ccompress' },
        { id: "07", skillType: 'web', skill: "MySQL", expertLevel: 98, logoUrl: 'https://www.logo.wine/a/logo/MySQL/MySQL-Logo.wine.svg' },
        { id: "08", skillType: 'web', skill: "Meterial-UI", expertLevel: 95, logoUrl: 'https://seeklogo.com/images/M/material-ui-logo-5BDCB9BA8F-seeklogo.com.png' },
        { id: "09", skillType: 'web', skill: "Bootstrap", expertLevel: 95, logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Bootstrap_logo.svg/768px-Bootstrap_logo.svg.png?20210507000024' },
        { id: "10", skillType: 'web', skill: "MdBootstrap", expertLevel: 95, logoUrl: 'https://mdbootstrap.com/wp-content/uploads/2018/06/logo-mdb-jquery-small.webp' },
        { id: "11", skillType: 'web', skill: "Tailwindcss", expertLevel: 95, logoUrl: tailwindCSS },
        { id: "12", skillType: 'web', skill: "CSS", expertLevel: 95, logoUrl: cssImage },
        { id: "13", skillType: 'web', skill: "HTML", expertLevel: 95, logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/HTML5_logo_and_wordmark.svg/180px-HTML5_logo_and_wordmark.svg.png' },

        { id: "14", skillType: 'programming', skill: "JavaScript", expertLevel: 90, logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/900px-JavaScript-logo.png?20120221235433' },
        { id: "15", skillType: 'programming', skill: "Java", expertLevel: 90, logoUrl: 'https://1000logos.net/wp-content/uploads/2020/09/Java-Logo-640x400.png' },
        { id: "16", skillType: 'programming', skill: "PHP", expertLevel: 90, logoUrl: 'https://www.php.net//images/logos/new-php-logo.svg' },
        { id: "17", skillType: 'programming', skill: "C++", expertLevel: 75, logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/ISO_C%2B%2B_Logo.svg/459px-ISO_C%2B%2B_Logo.svg.png?20170928190710' },
        { id: "18", skillType: 'programming', skill: "C", expertLevel: 80, logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/C_Programming_Language.svg/570px-C_Programming_Language.svg.png?20201031132917' },

        { id: "19", skillType: 'tools', skill: "Git", expertLevel: 95, logoUrl: 'https://git-scm.com/images/logo@2x.png' },
        { id: "20", skillType: 'tools', skill: "Firebase", expertLevel: 95, logoUrl: firebase },
        { id: "21", skillType: 'tools', skill: "Netlify", expertLevel: 95, logoUrl: netlify },
        { id: "22", skillType: 'tools', skill: "Heroku", expertLevel: 95, logoUrl: 'https://www3.assets.heroku.com/assets/logo-purple-08fb38cebb99e3aac5202df018eb337c5be74d5214768c90a8198c97420e4201.svg' },
        // { id: "23", skillType: 'tools', skill: "Web Pack", expertLevel: 90, logoUrl: '' },
        { id: "24", skillType: 'tools', skill: "VSCode", expertLevel: 95, logoUrl: vscode },
        { id: "25", skillType: 'tools', skill: "Dev Tool", expertLevel: 90, logoUrl: devTool },
        { id: "26", skillType: 'tools', skill: "Photoshop", expertLevel: 90, logoUrl: 'https://www.adobe.com/content/dam/acom/one-console/icons_rebrand/ps_appicon.svg' },
        { id: "27", skillType: 'tools', skill: "Illustrator", expertLevel: 90, logoUrl: 'https://www.adobe.com/content/dam/cc/icons/illustrator.svg' },
        { id: "28", skillType: 'tools', skill: "Adobe XD", expertLevel: 90, logoUrl: 'https://helpx.adobe.com/content/dam/help/en/xd/get-started/jcr_content/main-pars/step_with_text/step-with-text-pars/imageandtext/imageandtextimage/XD.png' },
        { id: "29", skillType: 'tools', skill: "Figma", expertLevel: 90, logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/a/ad/Figma-1-logo.png?20190122182216' },
    ];

    const [getSkill, setGetSkill] = useState([]);
    const [webStyle, setWebStyle] = useState(true);
    const [progStyle, setProgStyle] = useState(false);
    const [toolsStyle, setToolsStyle] = useState(false);


    useEffect(() => {
        const specificSkill = allSkill.filter(skill => skill.skillType === 'web');
        setGetSkill(specificSkill);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const handleWeb = () => {
        const specificSkill = allSkill.filter(skill => skill.skillType === 'web');
        setGetSkill(specificSkill);

        setWebStyle(true);
        setProgStyle(false);
        setToolsStyle(false);

    }

    const handleProgramming = () => {
        const specificSkill = allSkill.filter(skill => skill.skillType === 'programming');
        setGetSkill(specificSkill);

        setWebStyle(false);
        setProgStyle(true);
        setToolsStyle(false);
    }

    const handleTools = () => {
        const specificSkill = allSkill.filter(skill => skill.skillType === 'tools');
        setGetSkill(specificSkill);

        setWebStyle(false);
        setProgStyle(false);
        setToolsStyle(true);
    }

    return (
        <div id="skill-section" className="container skill">
            <div className="back-line d-flex align-items-center skill-title">
                <div className="front-box d-flex align-items-center">
                    <p className="d-flex align-items-center">My Skills</p>
                </div>
            </div>

            <button onClick={handleWeb} className={webStyle ? "btn btn-lg btn-success my-2 my-sm-0 btn-style" : "btn btn-lg btn-outline-success my-2 my-sm-0 btn-style"} >Web</button>
            <button onClick={handleProgramming} className={progStyle ? "btn btn-lg btn-success my-2 my-sm-0 btn-style" : "btn btn-lg btn-outline-success my-2 my-sm-0 btn-style"}>Programming</button>
            <button onClick={handleTools} className={toolsStyle ? "btn btn-lg btn-success my-2 my-sm-0 btn-style" : "btn btn-lg btn-outline-success my-2 my-sm-0 btn-style"}>Tools</button>

            <div className="row row-cols-1 row-cols-md-4 pt-4">
                {
                    getSkill.map(skill => <Progress key={skill.id} done={skill.expertLevel} title={skill.skill} logoUrl={skill.logoUrl}></Progress>)
                }
            </div>
        </div>
    );
};

export default Skill;